import {Sheet as ProviderSheet} from "react-modal-sheet";
import React, {ComponentProps} from "react";
import "./Sheet.css";

export default function Sheet(props: ComponentProps<typeof ProviderSheet>): React.JSX.Element {
    return (
        <ProviderSheet isOpen={props.isOpen} onClose={props.onClose}>
            <ProviderSheet.Container style={{backgroundColor: "#121212"}}>
                <ProviderSheet.Header/>
                <ProviderSheet.Content>
                    {props.children}
                </ProviderSheet.Content>
            </ProviderSheet.Container>
            <ProviderSheet.Backdrop/>
        </ProviderSheet>
    );
}